module.exports = __webpack_public_path__ + "58287d7d0cf11eb124f6fc7abebd6523.pdf";